<template>
  <canvas id="confetti"></canvas>
</template>

<script>
// import confetti from "canvas-confetti'"

export default {
  methods: {
    draw() {
      const confetti = require('canvas-confetti');
      console.log("confetti",confetti)
      let canvas = document.getElementById("confetti");
      var myConfetti = confetti.create(canvas, {
        resize: true,
        useWorker: true,
      });
      myConfetti({
        particleCount: 30,
        spread: 45,
        origin: { y: 0.6 },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
#confetti {
  position: absolute;
  width: 100%;
  height: 12rem;
  top: 0;
  left: 0;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/awardDialog/confetti.vue